import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}

const router = new Router({
  mode: 'history',
  base: `/${process.env.VUE_APP_URL_LANG}${process.env.VUE_APP_URL_TYPE}${process.env.VUE_APP_URL_NAME}`,
  routes: [
    {
      path: '/',
      name:
        process.env.VUE_APP_COMPANY === 'true'
          ? 'companyDetail'
          : 'eventDetail',
      component:
        process.env.VUE_APP_COMPANY === 'true'
          ? loadView('company-detail/CompanyDetail')
          : loadView('event-detail/EventDetail')
    },
    {
      path: '/company',
      name: 'companyDetail',
      component: loadView('company-detail/CompanyDetail')
    },
    {
      path: '/gracias/:reference/',
      name: 'ThankYou',
      component: loadView('thank-you-page/ThankYouPage')
    },
    {
      path: '/pago/:reference/',
      name: 'Payment',
      component: loadView('payment/Payment')
    },
    {
      path: '/compra/',
      name: 'Purchase',
      component: loadView('purchase/Purchase')
    },
    {
      path: '/compra-expirada/',
      name: 'PurchaseExpired',
      component: loadView('purchase-expired/PurchaseExpired')
    }
  ]
})

export default router
